import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "PeopleExperiences", webpackPrefetch: true */ './lazyIndex');
});
export var PersonaHeader = createLazyComponent(lazyModule, function (m) { return m.PersonaHeader; });
export var MultiPersonaHeader = createLazyComponent(lazyModule, function (m) { return m.MultiPersonaHeader; });
//# sourceMappingURL=index.js.map